import React, { useState } from "react";
import "./styles/index.scss";
import Button from "../../common/forms/button";
import Actions from "../../../actions";
import { connect } from "react-redux";
import { clickToLinkHandler } from "../../../helpers/utils";
import Delimiter from "../../common/forms/delimiter/Delimiter";
import DKFormTextInput from "../../common/widgets/formVariablesWidget/DKFormTextInput";

const LoginPage = (props) => {
  const { login, errors } = props;
  const [member, setMember] = useState({
    email: undefined,
    password: undefined,
  });

  const handleChange = (e) => {
    setMember({ ...member, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    if (e.type === "click" || (e.type === "keydown" && e.keyCode === 13)) {
      login(member);
    }
  };

  return (
    <React.Fragment>
      <div className="login-form-container">
        <div className="title">Login</div>
        <Delimiter type="headline" shift="18" />
        <div className="form-input-container">
          <DKFormTextInput
            id="login-email-input"
            dataTestId="input-login-email"
            label="Email"
            name="email"
            type="text"
            required
            onChange={handleChange}
            value={member.email}
          />
          {errors && errors.email && <p className="error">{errors.email}</p>}
        </div>
        <div className="form-input-container">
          <DKFormTextInput
            id="login-password-input"
            dataTestId="input-login-password"
            label="Password"
            name="password"
            type="password"
            required
            onChange={handleChange}
            value={member.password}
          />
          {errors && errors.password && (
            <p className="error">{errors.password}</p>
          )}
        </div>
        <Button
          id="login-button"
          data-testid="button-login-submit"
          type="primary"
          size="large"
          children={"Sign In"}
          onClick={handleSubmit}
        />
        <div className="links-container">
          <div
            className="link"
            onClick={() => {
              clickToLinkHandler("/recover");
            }}
          >
            Forgot Password
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => {
  const { formErrors: errors } = state.auth;

  return {
    errors,
  };
};

const mapDispatchToProps = (dispatch) => ({
  login: function (data) {
    dispatch(Actions.login(data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
